<template>
  <div class="dashboard">
    <v-dialog
      v-model="loading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by syncing WA Data
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card color="secondary">
      <v-card-text>
        <v-layout
          align-center
          justify-center
          wrap
        >
          <v-flex xs12 md3>
          </v-flex>
          <v-flex xs12 md2 mt-4 pa-1>
            <v-select
              :items="searchCats"
              v-model="selectedSearchCat"
              label="Search By"
              solo
              return-object
              clearable
              :loading="loading"
            ></v-select>
          </v-flex>
          <v-flex xs12 md4 mt-4 pa-1>
            <v-text-field
              label="Search"
              solo
              v-model="searchText"
              @input="filterLeads()"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 md3>
          </v-flex>
          <v-flex xs12>
            <v-btn @click="getCampaignsIds()" fab absolute right top color="primary" dark>
              <v-icon>sync</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-progress-linear v-if="loading" style="margin-top:0;margin-bottom:0;" :indeterminate="true"></v-progress-linear>
    <v-card>
      <v-layout row wrap px-5 py-1>
        <v-flex xs6 md6 px-1>
          <v-menu
            v-model="fd"
            :close-on-content-click="false"
            :nudge-right="40"
            :allowed-dates="fromDates"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="fDate"
                label="From"
                append-icon="event"
                readonly
                hide-details
                clearable
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker @change="filterLeads()" v-model="fDate" @input="fd = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md6 px-1>
          <v-menu
            v-model="td"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template slot="activator">
              <v-text-field
                v-model="tDate"
                label="To"
                append-icon="event"
                readonly
                clearable
                hide-details
                @change="filterLeads()"
                :loading="loading"
              ></v-text-field>
            </template>
            <v-date-picker @change="filterLeads()" v-model="tDate" @input="td = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 md3 px-1 mb-0>
          <v-autocomplete
            :items="waStatuses.map(x => x.toUpperCase())"
            v-model="selectedWAStatus"
            label="Select Wa Statuses"
            return-object
            clearable
            hide-details
            @change="filterLeads()"
            :loading="waLoading"
            v-if="!waLoading"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2>
          <v-progress-circular size="14" v-if="waLoading" indeterminate color="primary"></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout row wrap py-2>
      <v-flex xs12 sm12 md12>
          <div class="text-xs-center">
            <div><v-chip v-if="!loading" color="success" text-color="white">{{filteredLeads.length}} results</v-chip></div>
            <v-pagination
              v-model="currentPage"
              :length="pagesNumber"
              :total-visible="5"
              @input="updateVisible"
            ></v-pagination>
          </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap class=" ma-2">
      <v-flex v-if="loading" xs12 class="text-xs-center" ma-1>
        <v-card v-for="n in pageSize" class="elevation-4 pa-3 mt-1"  :key="n">
          <content-placeholders :rounded="true">
            <content-placeholders-heading :img="false" />
          </content-placeholders>
        </v-card>
      </v-flex>
      <v-flex xs12 ma-1>
        <v-card :class="`elevation-4 `">
          <v-layout row wrap class="px-2 pt-1">    
            <!-- <v-flex v-if="userRole == 'admin'" xs4 md2>
              <v-checkbox label="All on page" color="primary" @change="selectVisible()" v-model="selectVs" value="true" height="1" ></v-checkbox>
            </v-flex> -->
            <!-- <v-flex xs4 md2>
              <v-checkbox label="All results" color="primary" @change="selectVisible()" v-model="selectRs" value="true" height="1" ></v-checkbox>
            </v-flex> -->
            <v-flex xs4 md1>
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat color="secondary" 
                  small 
                  @click="dialogs.add = true" 
                  icon 
                >
                  <v-icon>add</v-icon>
                </v-btn>
                <span>Add a Lead</span>
              </v-tooltip>
            </v-flex>
            <v-flex v-if="userRole == 'admin'" xs4 md1>
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat color="secondary" 
                  small 
                  @click="dialogs.delete = true" 
                  icon 
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Delete {{selectedLeads.length!=0?selectedLeads.length:'' }}</span>
              </v-tooltip>
            </v-flex>
              <v-dialog v-model="dialogs.delete" persistent max-width="390">
                <v-card>
                  <v-card-title class="headline">Are You Sure?</v-card-title>
                  <v-card-text>
                    You are about to delete {{ selectedLeads.length }}, are you sure you want to do that?
                    <div class="error white--text pa-2 ma-3">NOTE: all data associated with {{ selectedLeads.length }} leads will be deleted completely from our servers, and it will be impossible to restore it</div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="dialogs.delete = false">cancel</v-btn>
                    <v-btn 
                      color="success" 
                      outline 
                      :loading="loading"
                      @click="deleteAll()"
                    >confirm</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            <v-flex v-if="userRole == 'admin'" xs4 md1>
              <v-tooltip top>
                <v-btn 
                  slot="activator" 
                  flat color="secondary" 
                  small 
                  @click="dialogs.editing = true" 
                  icon 
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>edit {{selectedLeads.length!=0?selectedLeads.length:'' }}</span>
              </v-tooltip>
              <v-dialog 
                persistent 
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
                v-model="dialogs.editing"
                >
                  <v-card>
                    <v-toolbar card dark color="secondary">
                      <v-btn icon dark @click="dialogs.editing = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                      <v-toolbar-title>Editing Details</v-toolbar-title>
                      <v-spacer></v-spacer>

                      <v-toolbar-items>
                        <v-btn dark flat @click="dialogs.editing = false">Cancel</v-btn>
                        <v-btn dark flat :loading="loading" @click="updateAllSelected()">Save</v-btn>
                      </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex v-for="l in selectedLeads" :key="l.key" xs12>
                          <v-card class="elevation-4 mb-2">
                            <v-layout row wrap class="pa-2">
                              <v-flex xs6 md4 px-2>
                                <v-text-field
                                  label="First Name"
                                  :value="l.firstname"
                                  v-model="l.firstname"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs6 md4 px-2>
                                <v-text-field
                                  label="Last Name"
                                  :value="l.lastname"
                                  v-model="l.lastname"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs6 md4 px-2>
                                <v-text-field
                                  label="Email"
                                  :value="l.email"
                                  v-model="l.email"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs6 md4 px-2>
                                <v-text-field
                                  label="Phone"
                                  :value="l.number"
                                  v-model="l.number"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <!-- <v-select
                                :items="crms"
                                label="CRM"
                                v-model="selectedCRM"
                                clearable
                                return-object
                                class="px-2"
                              ></v-select> -->
                              <v-btn outline color="primary" @click="updateLead(l)" small dark>Save</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-flex>
                      </v-layout> 
                    </v-card-text>
                    
                  </v-card>
                </v-dialog>
            </v-flex>
            <!-- <v-flex xs4 md1>
              <v-btn outline color="secondary" @click="exportCSV()" small dark>Export {{selectedLeads.length!=0?selectedLeads.length:'' }}</v-btn>
            </v-flex> -->
            <!-- <v-flex xs4 md1>
              <v-btn color="primary" @click="dialogs.email = true" small dark>{{ selectedLeads.length }} Email</v-btn>
            </v-flex> -->
            <v-flex v-if="userRole == 'admin'" xs4 md2>
              <v-btn color="primary" @click="dialogs.wa = true" small dark>{{ filteredLeads.length }} WA</v-btn>
            </v-flex>
            <v-flex v-if="userRole == 'admin'" xs4 md2>
              <v-btn color="primary" @click="checkWA()" small dark>Check WA</v-btn>
            </v-flex>
            <!-- <v-flex xs4 md1>
              <v-btn color="primary" @click="dialogs.sms = true" small dark>{{ selectedLeads.length }} SMS</v-btn>
            </v-flex> -->
            <v-flex xs4>
              <v-chip  v-if="imports ? imports.sending: false"  color="secondary" text-color="white">
                <v-btn fab flat small :loading="imports?imports.sending:false" dark></v-btn>
                WA MSGS / {{ imports.sent }}
                <v-btn v-if="superAdmin" fab icon color="primary" small dark>
                  <v-icon>sync_disabled</v-icon>
                </v-btn>
              </v-chip>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <!-- dialogs -->
      <v-dialog v-model="dialogs.email" persistent max-width="390">
        <v-card>
          <v-card-title class="headline">Choose a template to send to {{ selectedLeads.length }} leads</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                You are about to send the following Template to {{ selectedLeads.length }} leads, please choose a template
              </v-flex>
              <v-flex xs12 px-3 py-1>
                <v-select
                  :items="Etemplates"
                  v-model="selectedETemplate"
                  label="Choose a saved Template"
                  append-outer-icon="add"
                  solo
                  @click:append-outer="goTo('/email-templates')"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-progress-circular indeterminate v-if="loading" color="primary"></v-progress-circular>
            <v-spacer></v-spacer>
            <v-btn outline color="error" @click="dialogs.email = false">cancel</v-btn>
            <v-btn 
              color="success" 
              @click="launchEmailSending()"
              :loading="loading"
              :disabled="!selectedETemplate"
            >confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialogs -->
      <v-dialog v-model="dialogs.wa" persistent max-width="390">
        <v-card>
          <v-card-title class="headline">Send WA to {{ filteredLeads.length }} leads</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                You are about to send the following Message on WA to {{ filteredLeads.length }} leads
              </v-flex>
              <v-flex xs12 py-1>
                <span class="my-3">Use <span class="red--text">|Firstname|</span> &/OR <span class="red--text">|Lastname|</span> to include name</span>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Image URL OR Upload"
                  solo
                  v-model="waImage"
                  prepend-icon="cloud_upload"
                  :loading="iloading"
                  @click:prepend="pickFile()"
                ></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="file"
                  accept="csv/*"
                  @change="onFilePicked"
                >
              </v-flex>
              <v-flex xs12>
                <v-progress-linear v-model="upload" v-if="upload && upload > 0 && upload < 100" height="10px"></v-progress-linear>
              </v-flex>
              <v-flex xs12 py-1>
                
                <v-textarea
                  solo
                  label="Message"
                  v-model="sMessage"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-progress-circular indeterminate v-if="loading" color="primary"></v-progress-circular>
            <v-spacer></v-spacer>
            <v-btn outline color="error" @click="dialogs.wa = false">cancel</v-btn>
            <v-btn outline color="success" @click="checkWA()">Cheack WA auth</v-btn>
            <v-btn 
              color="success" 
              @click="sendWA()"
              :loading="loading"
              :disabled="!sMessage"
            >confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialogs -->
      <v-dialog fullscreen v-model="dialogs.qr" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">Please Scan QR</v-card-title>
          <v-card-text class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12>
                <img :src="qrCode">
              </v-flex>
              <v-flex xs12>
                <v-btn outline color="primary" @click="checkWA()" dark>Scan Then Click here</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-progress-circular indeterminate v-if="loading" color="primary"></v-progress-circular>
            <v-spacer></v-spacer>
            <v-btn outline color="error" @click="dialogs.qr = null">{{ qrCode ? 'cancel' : 'close' }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialogs -->
      <v-dialog v-model="dialogs.sms" persistent max-width="390">
        <v-card>
          <v-card-title class="headline">Send SMS to {{ selectedLeads.length }} leads</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                You are about to send the following Message on SMS to {{ selectedLeads.length }} leads
              </v-flex>
              <v-flex xs12 py-1>
                <span class="my-3">Use <span class="red--text">|Firstname|</span> &/OR <span class="red--text">|Lastname|</span> to include name</span>
              </v-flex>
              <v-flex xs12 py-1>
                <v-textarea
                  solo
                  label="Message"
                  v-model="sMessage"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outline color="error" @click="dialogs.sms = false">cancel</v-btn>
            <v-btn 
              color="success" 
              @click="sendSMS()"
              :disabled="!sMessage"
            >confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialogs -->
      <v-dialog v-model="dialogs.add" persistent max-width="390">
        <v-card>
          <v-card-title class="headline">Add Lead</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 py-1>
                <v-text-field
                  label="First Name"
                  v-model="addFirstname"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 py-1>
                <v-text-field
                  label="Last Name"
                  v-model="addLastname"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 py-1>
                <v-text-field
                  label="Email"
                  v-model="addEmail"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 py-1>
                <v-text-field
                  label="Number"
                  v-model="addNumber"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 py-1>
                <v-flex xs12 sm12 px-1 my-1>
                  <v-autocomplete
                    :items="countries"
                    item-text="name"
                    v-model="addCountry"
                    label="Country"
                  >
                  </v-autocomplete>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outline color="error" @click="dialogs.add = false">cancel</v-btn>
            <v-btn 
              color="success" 
              :disabled="!addNumber || !addLastname || !addEmail || !addFirstname || !addCountry"
              @click="addLead()"
            >add lead</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialogs -->
      <v-flex v-for="b in visibleLeads" :key="b.key" xs12 ma-1>
        <v-card :class="`elevation-4 `">
          <v-layout row wrap>    
            <v-flex xs12 md12 pa-2>
              <v-layout row wrap>
                <v-flex xs4 md1>
                  <v-tooltip top>
                    <span slot="activator" class="text-xs-center">
                      <v-checkbox hide-details class="smallerScale" label="select" color="primary" @change="getSelected()" v-model="selectedLeads" height="1" :value="b"></v-checkbox>
                    </span>
                    <span>Select Lead</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs4 md1>
                  <v-btn icon @click="()=>{ dialogs.editing = true; selectForEdit(b)  }" flat color="secondary" small  dark>
                    <v-icon size="22" >edit</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex v-if="b.date" xs4 md1>
                  <div class="caption grey--text ">Date</div>
                  <v-tooltip top>
                    <span slot="activator">{{ b.date | formatDate | truncate(5, '..') }}</span>
                    <span>{{ b.date }}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex v-if="b.name" xs4 md1>
                  <div class="caption grey--text ">Full Name</div>
                  <v-tooltip top>
                    <span slot="activator">{{ b.name | truncate(5, (b.name.length>5 ? '..': '')) }}</span>
                    <span>{{ b.name }}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex v-if="b.firstname" xs4 md1>
                  <div class="caption grey--text ">First Name</div>
                  <v-tooltip top>
                    <span slot="activator">{{ b.firstname | truncate(5, (b.firstname.length>5 ? '..': '')) }}</span>
                    <span>{{ b.firstname }}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex v-if="b.lastname" xs4 md1>
                  <div class="caption grey--text ">Last Name</div>
                  <v-tooltip top>
                    <span slot="activator">{{ b.lastname | truncate(5, (b.lastname.length>5 ? '..': '')) }}</span>
                    <span>{{ b.lastname }}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex v-if="b.email" xs4 md1>
                  <div class="caption grey--text ">Email</div>
                  <v-tooltip top>
                    <span slot="activator">{{ b.email | truncate(5, '..') }}</span>
                    <span>{{ b.email }}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex v-if="b.number" xs4 md1>
                  <div class="caption grey--text ">Phone</div>
                  <v-tooltip top>
                    <span slot="activator"
                      style="cursor:pointer;"
                      v-clipboard:copy="b.number"
                      v-clipboard:success="clipboardSuccessHandler"
                      v-clipboard:error="clipboardErrorHandler"
                    >{{ b.number | truncate(5, '..') }}</span>
                    <span>Click to Copy: {{ b.number }}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex v-if="b.country" xs4 md1>
                  <div class="caption grey--text ">Country</div>
                  <v-tooltip top>
                    <span slot="activator">{{ b.country | truncate(5, '..') }}</span>
                    <span>{{ b.country }}</span>
                  </v-tooltip>
                </v-flex>
                <!-- <v-flex xs4 md2>
                  <div class="caption grey--text ">Email Response</div>
                  <v-tooltip top>
                    <span slot="activator">
                      <v-icon size="17px" v-if="b.emails">check_circle_outline</v-icon> {{ b.emails ? getSentCount(b.emails).e : '0' }}
                      <span v-if="b.emails && getSentCount(b.emails).r">
                      /
                      <v-icon size="17px" color="primary" v-if="b.emails">check_circle</v-icon> {{ b.emails ? getSentCount(b.emails).r : '0' }}
                      </span>
                      <span v-if="b.emails && getSentCount(b.emails).r">
                      /
                      <v-icon size="17px" color="primary" v-if="b.emails">close</v-icon> {{ b.emails ? getSentCount(b.emails).o : '0' }}
                      </span>
                    </span>
                    <span>{{ b.emails ? `${getSentCount(b.emails).e} Emails Sent / ${getSentCount(b.emails).r} Unique Emails Opened / ${getSentCount(b.emails).o} Total Opens`: 'No Emails Sent'}}</span>
                  </v-tooltip>
                </v-flex> -->
                <v-flex xs4 md3>
                  <div class="caption grey--text ">WA Response</div>
                  <!-- <v-progress-linear :indeterminate="true" v-if="!b.was"></v-progress-linear> -->
                  <v-tooltip top v-if="b.wa">
                    <span slot="activator">
                      <span v-if="b.was.me">
                        <v-icon size="17px">trending_up</v-icon>
                        {{ b.was.me }}
                      </span>
                      <span v-if="b.was.sent">
                        <v-icon size="17px">done</v-icon>
                        {{ b.was.sent }}
                      </span>
                      <span v-if="b.was.del">
                        <v-icon size="17px">done_all</v-icon>
                        {{ b.was.del }}
                      </span>
                      <span v-if="b.was.view">
                        <v-icon size="17px" color="primary">done_all</v-icon>
                        {{ b.was.view }}
                      </span>
                      <span v-if="b.was.him">
                        <v-icon size="17px" color="primary">reply</v-icon>
                        {{ b.was.him }}
                      </span>
                      <span v-if="b.was.need">
                        <v-icon size="17px" color="success">fiber_manual_record</v-icon>
                      </span>
                    </span>
                    <span>{{ `${b.was.me} WA Messages / ${b.was.sent} Sent / ${b.was.del} Delivered / ${b.was.view} Viewed / ${b.was.him} Replies / ${b.was.need ? 'Need Reply' : ''}` }}</span>
                  </v-tooltip>
                </v-flex>
                <!-- <v-flex xs4 md1>
                  <v-tooltip top>
                      <v-btn icon small slot="activator" color="primary" flat dark>
                        <v-icon size="22">send</v-icon>
                      </v-btn>
                    <span>Send Whatsapp</span>
                  </v-tooltip>
                </v-flex> -->
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap py-3>
      <v-flex xs12 sm12 md12>
          <div class="text-xs-center">
            <v-pagination
              v-model="currentPage"
              :length="pagesNumber"
              :total-visible="5"
              @input="updateVisible"
            ></v-pagination>
          </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {firebase, db, auth, storageRef } from '@/fb';
import dashboardParalex from '../components/dashboardParalex';
import MiniStatistic from '@/components/MiniStatistic';
import { getRandomInt, randomString, getCDate, check, uuid } from '@/customFunction';
import axios from 'axios';
import Papa from 'papaparse'

export default {
  components:{ dashboardParalex, MiniStatistic},
  data() {
    return {
      fd:false,
      td:false,
      loading:true,
      dialogs:{
        delete:false,
        editing:false,
        export:false,
        email:false,
        sms:false,
        wa:false,
        add:false,
        qr:false,
      },
      qrCode:null,
      selectedCRM:null,
      waLoading:false,
      leads:[],
      imports:null,
      visibleLeads:[],
      filteredLeads:[],
      searchCats:[],
      selectedSearchCat:null,
      searchText:'',
      countries:[],
      selectedCountries:null,
      campaigns:[],
      selectedCampaign:null,
      contents:[],
      selectedContent:null,
      referrers:[],
      fDate:null,
      fromDates:[],
      selectedFromDates:null,
      tDate:null,
      toDates:[],
      selectedToDates:null,
      selectedReferrer:null,
      selectedLeads:[],
      selectVs:false,
      selectRs:false,
      isLoading:false,
      currentPage: 1,
      pageSize: 10,
      pagesNumber:0,
      width:5,
      onlyNotSent:false,
      alreadySent:false,
      leadPlus:false,
      onlyFTD:false,
      loadedETemplates:[],
      Etemplates:[],
      selectedETemplate:null,
      sMessage:null,
      countries:[],
      addFirstname:null,
      addLastname:null,
      addEmail:null,
      addCountry:null,
      addNumber:null,
      waImage:null,
      iloading:false,
      upload:null,
      fileUploading:null,
      file:null,
      waStatuses:['has no whatsapp', 'has whatsapp', 'replied', 'need reply'],
      selectedWAStatus:null,
    }
  },
  computed:{
    
  },
  methods: {
    getWA(wa){
      let e = 0
      let s = 0
      let d = 0
      let r = 0
      let h = 0
      let n = false
      let msgs = []
      for (const key in wa) {
        if (wa.hasOwnProperty(key)) {
          const message = wa[key];
          msgs.push(message)
          if(message.fromme == 'True')e++
          if(message.fromme == 'False')h++
          if(message.sent) s++
          if(message.delivered) d++
          if(message.viewed) r++
        }
      }
      if(msgs.lenght!=0 && msgs[msgs.length-1] && msgs[msgs.length-1].fromme == 'False') n = true
      return {e, s, d, r, h, n}
    },
    getSentCount(emails) {
      let e = 0
      let r = 0
      let o = 0
      for (const key in emails) {
        if (emails.hasOwnProperty(key)) {
          const email = emails[key];
          e++
          if(email.opens) {
            r++
            for (const key in email.opens) {
              if (email.opens.hasOwnProperty(key)) {
                o++
              }
            }
          } 
        }
      }
      return {e, r, o}
    },
    addLead(){
      if(!this.addNumber || !this.addLastname || !this.addEmail || !this.addFirstname || !this.addCountry) return
      this.loading = true
      let lead = {
          firstname:this.addFirstname,
          lastname:this.addLastname, 
          number:this.addNumber,
          country:this.addCountry,
          email:this.addEmail,
          date:getCDate()
        }
      function checkN(lead) {
          return db.ref('data')
          .orderByChild('number')
          .equalTo(`${lead.number}`)
          .once('value')
          .then(x=>{
            return x.val()
          })
        }
        function checkE(lead) {
          return db.ref('data')
          .orderByChild('number')
          .equalTo(`${lead.number}`)
          .once('value')
          .then(x=>{
            return x.val()
          })
        }
        checkN(lead).then(x=>{
          checkE(lead).then(y=>{
            if (!x && !y) {
              db.ref('data')
              .push(lead)
              .then(x=>{
                this.$emit('snackbarNotification', `Unique Lead Stored Successfully`, 'success')
                this.dialogs.add = false
                this.loading = false
              })
            } else {
              this.$emit('snackbarNotification', `Lead email or phone is already in DB`, 'error')
              this.dialogs.add = false
              this.loading = false
            }
          })
        })
    },
    importActive(){
      db.ref('whatsapp/bulk')
      .on('value', snap=>{
        this.imports = snap.val()
      })
    },
    loadFile(file){
      var file = file
      this.iloading = true
      var metadata = {
        contentType: 'image/jpeg'
      };
      var uploadTask = storageRef.child('images/image' + randomString(8, 'Aa#') + '.jpg').put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.upload = progress
                }, (error) =>{
          console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
          console.log('File available at', downloadURL);
          this.waImage = downloadURL
          this.iloading = false
        });
      });
    },
    getWAObj(n){
      this.waLoading = true
      return db.ref(`whatsapp/96262000458/${parseInt(n)}/messages`)
      .once('value')
      .then(m=>{
        return m.val()
      })
    },
    getCampaignsIds() {
      this.loading = true
      axios.get(`https://us-central1-ashyaatcrm.cloudfunctions.net/main/getDataWAStats`)
      .then(x=>{
        db.ref('data/')
        .once('value')
        .then(snap=>{
          let leads = snap.val()
          for (const key in leads) {
            if (leads.hasOwnProperty(key)) {
              const lead = leads[key];
              if (lead) {
                lead.key = key
                lead.dialog = false
                this.searchCats = Object.keys(lead)
                .filter(x => x != 'date' && x != 'key' && x != 'dialog')
                .map(x => x.toUpperCase())
                let index = this.leads.findIndex(x => x.key === lead.key)
                if(index != -1) this.leads.splice(index, 1, lead); 
                if(index === -1) this.leads.push(lead)
              }
            }
          }
          this.visibleLeads = this.leads
          this.filteredLeads = this.leads
          this.getPagesNumber()
          this.updateVisible()
        })
      })
    },
    updateVisible() {
      this.sortByDate()
      this.visibleLeads = this.filteredLeads.slice((this.currentPage -1) * this.pageSize, ((this.currentPage -1) * this.pageSize) + this.pageSize);
      this.loading = false
    },
    filterLeads() {
      this.loading = true
      this.filteredLeads = this.leads
      .filter(lead=>{
        if(!this.searchText || this.searchText == '' || this.searchText == null) return lead
        if(!this.selectedSearchCat) return lead
        let search = this.searchText.toLowerCase()
        let key = this.selectedSearchCat.toLowerCase()
        if(lead[key].toLowerCase().includes(search)) return lead
      })
      .filter(lead=>{
        if(!this.fDate) return lead
        if(!this.tDate) return lead
        let t = new Date(lead.date).getTime()
        let x = new Date(this.fDate).getTime() - 4 * 1000*60*60
        let y = new Date(this.tDate).getTime() + 20 * 1000*60*60 - 1000
        if ( t > x && t < y) return lead
      })
      .filter(lead=>{
        if(!this.selectedWAStatus) return lead
        if (lead.was) {
          if(this.selectedWAStatus.toLowerCase() == 'need reply' && lead.was.need) return lead
          if(this.selectedWAStatus.toLowerCase() == 'has whatsapp' && lead.was.sent > 0) return lead
          if(this.selectedWAStatus.toLowerCase() == 'replied' && lead.was.him > 0) return lead
        } else {
          if(this.selectedWAStatus.toLowerCase() == 'has no whatsapp' && !lead.was) return lead
        }
      })
      this.getPagesNumber()
      this.currentPage = 1
      this.updateVisible()
    },
    sortByDate(){
      this.filteredLeads = this.filteredLeads.sort(function(a,b){
        return new Date(b.date) - new Date(a.date);
      });
    },
    getPagesNumber(){
      if (this.filteredLeads.length % this.pageSize == 0) {
        this.pagesNumber = parseInt(this.filteredLeads.length / this.pageSize)
      } else {
        this.pagesNumber = parseInt(this.filteredLeads.length / this.pageSize) + 1
      }
    },
    avgRatings(r){
      let count = Object.keys(r).length
      let total = 0
      for (const key in r) {
        if (r.hasOwnProperty(key)) {
          const rO = r[key];
          total += parseInt(rO.rating)
        }
      }
      return  parseInt(total / count)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    selectVisible(t){
      this.selectedLeads = []
      if (this.selectVs) {
        this.visibleLeads.forEach(x=> {
          this.selectedLeads.push(x)
        })
      } else {
        this.selectedLeads = []
      }
      if (this.selectRs) {
        this.filteredLeads.forEach(x=> {
          this.selectedLeads.push(x)
        })
      } else if (!this.selectVs) {
        this.selectedLeads = []
      }
    },
    selectForEdit(b){
      this.selectVs = false
      this.selectRs = false
      this.selectedLeads = []
      this.selectedLeads.push(b)
    },
    getSelected(){
      let x = this.selectedLeads
    },
    
    updateLead(l) {
      this.loading = true
      db.ref(`data/${l.key}`)
        .update(l)
        .then(x=>{
          this.$emit('snackbarNotification', `${l.key} Updated`, 'success')
          this.loading = false
          if (this.selectedLeads.length == 1) {
            this.dialogs.editing = false
          }
        })
    },
    launchEmailSending(){
      this.loading = true
      setTimeout(x=>{
        this.sendEmail()

      }, 500)
    },
    sendEmail() {
      if (this.selectedLeads.length == 0) {
        return
      }
      this.loading = true
      let count = 0
      this.selectedLeads.forEach(l=>{
        console.log(l)
        let cuid = randomString(12, 'Aa#')
        let email = {
          firstname:l.lastname,
          lastname:l.firstname, 
          templatekey:this.selectedETemplate,
          email:l.email,
          trackID: cuid
        }
        console.log(email)
        var headers = {
          'Accept': 'application/json'
        }
        let p = db.ref('data/' + l.key + '/emails').push({
          template:email.templatekey,
          trackID: cuid,
          date:getCDate()
        })
        db.ref(`tracking`).update({
            [cuid]: {
              lead:l.key,
              type:'emails',
              id:p.key,
              date:getCDate()
          }
        })
        .then(x=>{
          axios.post(`https://hooks.zapier.com/hooks/catch/3025095/j6ehuc/`, JSON.stringify(email), {headers: headers})
          .then(resp=>{
            count++
            if (count == this.selectedLeads.length) {
              if (resp.data.status == 'success') {
                this.$emit('snackbarNotification', `Sent Successfully`, 'success')
                this.loading = false
                this.dialogs.email = false

              } else {
                this.$emit('snackbarNotification', `Sending Failed`, 'error')
                this.loading = false
                this.dialogs.email = false
              }
            }
          })
        })
      })
    },
    checkWA(){
      this.loading = true
      let token = 'w2oafw2an00eddry'
        return axios.get(`https://eu13.chat-api.com/instance43086/status?token=${token}`)
        .then(res=>{
          console.log(res.data);
          this.loading = false
          if (res.data.qrCode) {
            this.dialogs.qr = true
            this.loading = false
            this.qrCode = res.data.qrCode
            this.$emit('snackbarNotification', `Please scan QR code`, 'success')
          } else if(res.data.accountStatus == 'authenticated'){
            this.dialogs.qr = false
            this.qrCode = null
            this.loading = false
            this.$emit('snackbarNotification', `Ready to send`, 'success')
            return 'auth'
          } else {
            this.loading = false
            this.$emit('snackbarNotification', `Please Login to chat-api.com and click USE HERE`, 'success')
            setTimeout(x=>{
              window.open('https://app.chat-api.com/')
            }, 2000)
          }
        })
    },
    sendWA(){
      this.checkWA()
      .then(x=>{
        if(x =='auth') {
          this.$emit('snackbarNotification', `Started Sending`, 'success')
          let post = {
            msg:this.sMessage,
            img:this.waImage?this.waImage:null,
            filter:{
              search:this.searchText ? this.searchText : null,
              searchcat:this.selectedSearchCat ? this.selectedSearchCat : null,
              fdate:this.fDate ? this.fDate : null,
              tdate:this.tDate ? this.tDate : null,
              status:this.selectedWAStatus
            }
          }
          var headers = {
            'Accept': 'application/json'
          }
          axios
          .post(`https://us-central1-ashyaatcrm.cloudfunctions.net/main/waBulk`, post, {headers: headers})
          .then(re=>{
            console.log(re)
            this.dialogs.wa = false
            this.goTo('/wa-campaigns')
          })
        }
      })

    },
    pickFile (f) {
      this.$refs.file.click ()
      this.fileUploading = f
    },
    onFilePicked (e) {
      this.iloading = true
			const files = e.target.files
			if(files[0] !== undefined) {
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.loadFile(this.file)
				})
			} else {
			
			}
    },
    sendSMS() {
      if (this.selectedLeads.length == 0) {
        return
      }
      this.loading = true
      let count = 0
      this.selectedLeads.forEach(contact=>{
        let sms = {
          firstname:contact.lastname,
          lastname:contact.firstname, 
          templatekey:this.selectedTemplate,
          number:contact.number
        }
        console.log(sms)
        var headers = {
          'Accept': 'application/json'
        }
        axios.post(`https://hooks.zapier.com/hooks/catch/3025095/jh6zla/`, JSON.stringify(sms), {headers: headers})
        .then(resp=>{
          count++
          if (count == this.selected.length) {
            if (resp.data.status == 'success') {
              this.$emit('snackbarNotification', `Sent Successfully`, 'success')
            } else {
              this.$emit('snackbarNotification', `Sending Failed`, 'error')
            }
            this.loading = false
          }
          
        })
      })
    },
    updateAllSelected(){
      console.log(this.selectedLeads)
      this.loading = true
      
      for (let i = 0; i < this.selectedLeads.length; i++) {
        const l = this.selectedLeads[i];
        db.ref(`data/${l.key}`)
        .update(l)
        .then(x=>{
          if (i == this.selectedLeads.length - 1) {
            this.dialogs.editing = false
            this.$emit('snackbarNotification', `All Selected Leads Updated`, 'success')
            this.loading = false
          }
        })
      }
    },
    exportCSV(){
      let config = {
        quotes: false, //or array of booleans
        quoteChar: '"',
        escapeChar: '"',
        delimiter: ",",
        header: true,
        newline: "\r\n",
        skipEmptyLines: false, //or 'greedy',
        columns: null //or array of strings
      }
      const flattenObject = (obj, prefix = '') =>
      Object.keys(obj).reduce((acc, k) => {
        const pre = prefix.length ? prefix + '.' : '';
        if (typeof obj[k] === 'object') Object.assign(acc, flattenObject(obj[k], pre + k));
        else acc[pre + k] = obj[k];
        return acc;
      }, {});
      let expArr = []
      this.selectedLeads.forEach(l=>{
        expArr.push(flattenObject(l))
      })
      console.log('------------------------------------');
      console.log(expArr);
      console.log('------------------------------------');
      var csv = Papa.unparse(expArr)
      var csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
      var csvURL =  null;
      if (navigator.msSaveBlob) {
        csvURL = navigator.msSaveBlob(csvData, 'download.csv');
      }
      else {
        csvURL = window.URL.createObjectURL(csvData);
      }
      var tempLink = document.createElement('a');
      tempLink.href = csvURL;
      tempLink.setAttribute('download', 'download.csv');
      tempLink.click();
    },
    deleteAll() {
      if(this.selectedLeads.length ==0) return;
      let leads = this.selectedLeads;
      (async ()=> {
				for (let i = 0; i < leads.length; i++) {
					const lead = leads[i];
					await db.ref(`data`).update({[lead.key]:null})
					if (i == leads.length - 1) {
						this.$emit('snackbarNotification', `All Selected Deleted Successfully`, 'success')
					}
				}
			})();
    },
    checkLead(b) {
      check(b)
    },
    goTo(path) {
      this.$router.push(path)
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    getTemplates(){
      return db.ref('emails/templates')
      .on('value', t=>{
        let templates = t.val()
        this.loadedETemplates = templates
        console.log(templates)
        for (const key in templates) {
            if (templates.hasOwnProperty(key)) {
              const template = templates[key];
              this.Etemplates.push({
                text:template.templateName,
                value:key
              })
            }
        }
      })
    },
  },
  watch: {
    selectedLeads(){
      console.log('------------------------------------');
      console.log(this.selectedLeads);
      console.log('------------------------------------');
    }
  },
  props: {
    userName: {
      required: true,
      default: 'GetCalls.io'
    },
    userImage: {
      required: true,
      default: ''
    },
    userRole: {
      required: true,
      default: 'user'
    }, 
    superAdmin: {
      required: true,
      default: false
    }, 
  },
  created() {
    fetch('https://restcountries.eu/rest/v2/all').then((response) => {
      return response.json().then((json) => {
        json.forEach(country => {
          this.countries.push(country.name)
        });
      })
    })
    this.getCampaignsIds()
    this.getTemplates()
    this.importActive()
    let gg = new Date(1559167938000)
    let mm = new Date(1559170604836)
    console.log('------------------------------------');
    console.log(gg);
    console.log(mm.getTime());

    console.log('------------------------------------');
    
    
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style>
.customSwitch {
  transform: scale(0.8);
  margin-top: 10px;
}

</style>
